<template>
  <div>
    <!-- Drawer for display on mobile -->
    <v-navigation-drawer
      v-if="this.$vuetify.breakpoint.smAndDown"
      v-model="drawer"
      app
      bottom
      temporary
    >
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="@/assets/logo_joseph.png"></v-img>
        </v-list-item-avatar>

        <v-list-item-content>
          <v-list-item-title>Joseph Perrin</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list dense>
        <v-list-item v-for="link in links" :key="link.title" link>
          <v-list-item-content>
            <v-list-item-title>
              <v-btn :to="link.url" text tile large block>{{
                link.title
              }}</v-btn>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar
      v-if="this.$vuetify.breakpoint.smAndDown"
      class="nav-bar"
      fixed
      bottom
      hide-on-scroll
      color="#303030"
    >
         <v-spacer/>
      <v-toolbar-items >
   
        <v-btn to="/projects" text><v-icon>mdi-lightbulb-on</v-icon></v-btn>
        
        <v-btn class="mx-8" @click="drawer = !drawer" text><v-icon>mdi-menu</v-icon> </v-btn
        ><v-btn to="/resume" text><v-icon>mdi-file-account</v-icon></v-btn
        ></v-toolbar-items
      >
           <v-spacer/>
    </v-app-bar>

    <v-app-bar v-else color="#303030" fixed hide-on-scroll elevate-on-scroll>
      <v-toolbar-title>Joseph Perrin</v-toolbar-title>
      <v-spacer/>
      <v-toolbar-items>
        <v-tooltip v-for="link in links" :key="link.title" bottom>
          <template v-slot:activator="{ on }">
            <v-btn :to="link.url" v-on="on" text>{{ link.title }}</v-btn>
          </template>
          <span>{{ link.subtitle }}</span>
        </v-tooltip>
      </v-toolbar-items>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  name: "NavBar",
  data() {
    return {
      drawer: null,
      links: [
        {
          title: "Home",
          subtitle: "Go back to the home page",
          icon: "dashboard",
          url: "/home",
        },
        {
          title: "Projects",
          subtitle: "Check my projects",
          icon: "dashboard",
          url: "/projects",
        },
        {
          title: "Resume",
          subtitle: "See my resume",
          icon: "dashboard",
          url: "/resume",
        },
        {
          title: "Contact",
          subtitle: "Keep in touch",
          icon: "dashboard",
          url: "/contact",
        },
      ],
    };
  },
};
</script>
